import { render, staticRenderFns } from "./InformativeView.vue?vue&type=template&id=7e1afa44&"
import script from "./InformativeView.vue?vue&type=script&lang=js&"
export * from "./InformativeView.vue?vue&type=script&lang=js&"
import style0 from "./InformativeView.vue?vue&type=style&index=0&id=7e1afa44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports